import React from "react";
import { StatusWithStream } from "@/features/betting/components/StatusWithStream";
import { useBetslipStore } from "@/features/betslip/stores/betslipStore";
import type { BetSelection } from "@/features/betslip/types";

type SelectionEventStatusProps = {
  selection: BetSelection;
};

export const SelectionEventStatus = ({
  selection,
}: SelectionEventStatusProps) => {
  // The selection's own eventStatus is frozen at add time, so a match that
  // kicks off mid-slip would keep counting down past zero.
  const syncedStatus = useBetslipStore(
    (s) => s.eventStatuses[selection.eventId],
  );
  // SEM bundle id never syncs, only its legs do - check legs instead.
  const syncedBettingType = useBetslipStore((s) => {
    if (selection.kind !== "sem") {
      return s.marketBettingTypes[selection.outcomeId];
    }

    const anyLegLive = selection.legs.some(
      (leg) => s.marketBettingTypes[leg.outcomeId] === "Live",
    );
    return anyLegLive
      ? "Live"
      : s.marketBettingTypes[selection.legs[0]?.outcomeId];
  });

  return (
    <StatusWithStream
      status={syncedStatus ?? selection.eventStatus ?? "ACTIVE"}
      scheduledStartTime={selection.startTime}
      bettingType={syncedBettingType}
      title={selection.eventName}
      sport={selection.sport}
      url={selection.streamUri}
      eventId={selection.eventId}
      eventUrl={selection.eventUrl}
      isPlaceholder={false}
    />
  );
};
